module.exports = __webpack_public_path__ + "ai.81e46c1dc709f0f84c46.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/ai.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/ai.svg
// module chunks = styles